import { DatePipe, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash-es';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-pin-code-pop-up',
  templateUrl: './pin-code-pop-up.component.html',
  styleUrls: ['./pin-code-pop-up.component.scss']
})
export class PinCodePopUpComponent implements OnInit {
  text: any;
  firstFormGroup: UntypedFormGroup;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    public datepipe: DatePipe,
    public loc: Location,
    private route: ActivatedRoute,
    private dialogRef: MatDialogRef<PinCodePopUpComponent>,
    private dialog: MatDialog,
    private userService :UserService

  ) { }

  ngOnInit() {

    this.initPincodePricingGroup();

    let pincode = localStorage.getItem("pincode");

    this.firstFormGroup.patchValue({
      pincode: pincode
    });   
   
  }



  close() {
    this.dialogRef.close({ event: 'close' })
  }

  back() {
    this.loc.back();
  }
  closeAll(){
    this.dialogRef.close();
  }
  initPincodePricingGroup() {
    this.firstFormGroup = this._formBuilder.group({
      pincode: [''],
    });
  }


  savePincodePricing() {
    if (this.firstFormGroup.valid) {
      
      localStorage.setItem("pincode", this.firstFormGroup.value.pincode);

      this.dialog.closeAll();

      this.userService.reload();

    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }


}
